
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import SolutionsSection from './components/SolutionsSection';

const CadresPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <HeroSection />
        <SolutionsSection />
      </main>
      <Footer />
    </div>
  );
};

export default CadresPage;
